import React from 'react';
import styles from './Button.module.css';

export default function Button({
    children,
    variant = 'primary',
    shape = 'pill',
    leadingIcon,
    trailingIcon,
    className,
    ...props
}) {
    const hasText = Boolean(children);
    const isIconOnly = !hasText && (leadingIcon || trailingIcon);

    return (
        <button
            className={[
                styles.btn,
                styles[`btn-${variant}`],
                styles[`shape-${shape}`],
                isIconOnly ? styles.iconOnly : '',
                className,
            ].join(' ').trim()}
            {...props}
        >
            {leadingIcon && <span className={styles.icon}>{leadingIcon}</span>}
            {hasText && <span className={styles.labelText}>{children}</span>}
            {trailingIcon && <span className={styles.icon}>{trailingIcon}</span>}
        </button>
    );
}
